function getSelectedValue(productId) {
  // Get all radio inputs
  var radioInputs = document.getElementsByName('id-' + productId);
  console.log(productId);

  // Iterate through the radio inputs to find the checked one
  for (var i = 0; i < radioInputs.length; i++) {
    if (radioInputs[i].checked) {
      // Retrieve and display the value of the checked radio input
      return radioInputs[i].value;
    }
  }

  // If no radio input is checked, display a message
  alert('Please select an option.');
  hideLoadingState(event.target.id);
  errorAddedToCart(event.target.id);
  return;
}

function addToCart(event, productId) {
  event.preventDefault();

  console.log(event);

  console.log(event.target.id);

  showLoadingState(event.target.id);

  var variantId = getSelectedValue(productId);

  //Catch and return if no variant is selected
  if (!variantId) {
    return;
  }

  var addData = {
    id: variantId,
    quantity: 1,
  };

  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest',
    },
    method: 'POST',
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      /* we have JSON */
      console.log(json);
      var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          //updateCartDrawer(data);
          //Turned off due to using CornerCart
          //openCartDrawer();
          hideLoadingState(event.target.id);
          confirmAddedToCart(event.target.id);

          //Show top header cart count and shake it
          //Now handled in the header section (updateCartBubbleCount())
          //document.querySelector('.shopify-section').classList.remove('shopify-section-header-hidden');

          //document.querySelector('.button--cart').classList.add('shake');
        });
    })
    .catch(function (err) {
      alert('There was an error adding the item to your cart. Please try again.');
      hideLoadingState(event.target.id);
      errorAddedToCart(event.target.id);
      console.error(err);
    });
}

function showLoadingState(buttonId) {
  console.log('Showing loading...');

  //Disable to button to avoid multiple clicks
  var addToCartButton = document.getElementById(buttonId);

  addToCartButton.disabled = true;

  var loadingSpinner = document.querySelectorAll('#' + buttonId + ' .loading_spinner_cart');
  var addToCartText = document.querySelectorAll('#' + buttonId + ' .add-to-cart-text');

  loadingSpinner.forEach(function (element) {
    element.classList.remove('hidden');
  });

  addToCartText.forEach(function (element) {
    element.classList.add('hidden');
  });
}

function hideLoadingState(buttonId) {
  console.log('Hiding loading...');

  var loadingSpinner = document.querySelectorAll('#' + buttonId + ' .loading_spinner_cart');
  var addToCartText = document.querySelectorAll('#' + buttonId + ' .add-to-cart-text');

  loadingSpinner.forEach(function (element) {
    element.classList.add('hidden');
  });
}

function confirmAddedToCart(buttonId) {
  var addToCartText = document.querySelectorAll('#' + buttonId + ' .add-to-cart-text');
  var addedToCart = document.querySelectorAll('#' + buttonId + ' .added-to-cart');

  addedToCart.forEach(function (element) {
    element.classList.remove('hidden');
  });

  setTimeout(function () {
    addedToCart.forEach(function (element) {
      element.classList.add('hidden');
    });

    addToCartText.forEach(function (element) {
      element.classList.remove('hidden');
    });

    //Enable the button after the request is complete
    var addToCartButtons = document.getElementById(buttonId);

    addToCartButtons.disabled = false;
  }, 1000);
}

function errorAddedToCart(buttonId) {
  var addToCartText = document.querySelectorAll('#' + buttonId + ' .add-to-cart-text');
  var errorAddingToCart = document.querySelectorAll('#' + buttonId + ' .error-adding-to-cart');

  errorAddingToCart.forEach(function (element) {
    element.classList.remove('hidden');
  });

  //Disable to button to avoid multiple clicks
  var addToCartButton = document.getElementById(buttonId);

  addToCartButton.disabled = false;

  setTimeout(function () {
    errorAddingToCart.forEach(function (element) {
      element.classList.add('hidden');
    });

    addToCartText.forEach(function (element) {
      element.classList.remove('hidden');
    });
  }, 1100);
}